<template>
  <v-container>
    <EditForm />

    <v-divider class="section-divider" />

    <SubscriptionForm />
  </v-container>
</template>

<script>
import EditForm from './EditForm'
import SubscriptionForm from './SubscriptionForm'

export default {
  name: 'PersonalInformationContent',
  components: {
    EditForm,
    SubscriptionForm,
  },
}
</script>

<style lang="scss" scoped></style>
